module.exports = __webpack_public_path__ + "static/media/point-left.4d0df049.gif";